import { render } from "./HeaderChallenge.vue?vue&type=template&id=3c2d0fc9&scoped=true"
import script from "./HeaderChallenge.vue?vue&type=script&lang=js"
export * from "./HeaderChallenge.vue?vue&type=script&lang=js"

import "@/css/components/header-challenge.css?vue&type=style&index=0&id=3c2d0fc9&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2d0fc9"]])

export default __exports__